import React from 'react';
import {LoadingOverlay} from '@homeaway/react-loading-overlay';

import ErrorPage from 'presentational/ErrorPage/ErrorPage';

const withQuery = (Component) => {
    return function WithQueryComponent(props) {
        const {response} = props;

        if (response.loading) {
            return <LoadingOverlay />;
        }

        if (response.error) {
            return <ErrorPage {...props} />;
        }

        return <Component {...props} />;
    };
};

export default withQuery;
